import { createTheme } from '@airbus/elements/theming'

const defaultTheme = createTheme('airbus')

export default defaultTheme
